export default {
    routes_edit: "Editar",
}